import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import globalColors from "../../../globalColors";
import { FontFamily } from "../Preview/getAlphabetForIndex";
export enum QuizAttemptLanguage {
  primaryLanguage = "primary_language",
  secondaryLanguage = "secondary_language",
}
export interface QuizLanguageToggleProps {
  languages: string[];
  selectedLang: string;
  handleQuizLanguageToggled: (attemptLanguage: string) => void;
}

const QuizLanguageToggle: FC<QuizLanguageToggleProps> = ({
  languages,
  selectedLang,
  handleQuizLanguageToggled,
}) => {
  return (
    <Stack position={"relative"}>
      {languages.length < 2 && (
        <Stack
          bgcolor={"rgba(255, 255, 255, 0.5)"}
          position={"absolute"}
          width={"100%"}
          height={"100%"}
          top={0}
          left={0}
        ></Stack>
      )}
      <Stack
        bgcolor={"rgba(18, 18, 18, 0.04)"}
        p={"2px"}
        borderRadius={"40px"}
        overflow={"hidden"}
        direction={"row"}
        width={"fit-content"}
      >
        {languages.map((s) => {
          return (
            <Stack
              width={"60px"}
              key={s}
              bgcolor={selectedLang === s ? globalColors.primary.pureWhite : ""}
              border={selectedLang === s ? "1px solid #DFDFDF" : ""}
              borderRadius={"32px"}
              height={"24px"}
              sx={{cursor:selectedLang === s ?"auto":"pointer"}}
              justifyContent={"center"}
              alignItems={"center"}
              onClick={(event:any) => {
                event.stopPropagation();
                handleQuizLanguageToggled(s);
              }}
            >
              <Typography
                fontSize={"12px"}
                fontStyle={"normal"}
                fontWeight={selectedLang === s ? 500 : 400}
                lineHeight={"normal"}
                color={globalColors.primary.black}
                fontFamily={FontFamily.gilroy}
                textTransform={"capitalize"}
              >
                {s}
              </Typography>
            </Stack>
          );
        })}

        {languages.length === 1 && (
          <Stack
            width={"60px"}
            borderRadius={"32px"}
            height={"24px"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography
              fontSize={"12px"}
              fontStyle={"normal"}
              fontWeight={400}
              lineHeight={"normal"}
              color={globalColors.primary.black}
              fontFamily={FontFamily.gilroy}
              textTransform={"capitalize"}
            >
              Hindi
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default QuizLanguageToggle;
